import {
  Typography,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as customColors from "../../theme/customColors";

// Original optional props:
// children
// defaultExpanded

// Extended optional props:
// summaryText

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    backgroundColor: customColors.lightBlue,
    color: "white",
    marginBottom: -1,
    minHeight: 50,
    "&$expanded": {
      minHeight: 50
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiAccordionDetails);

const CustomAcordion = (props) => {
  return (
    <Accordion square className={props.className} defaultExpanded={props.defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{props.summaryText}</Typography>
        {props.summaryActions ? (
          <div
            className="accordion-summary-actions"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            {props.summaryActions}
          </div>
        ) : null}
      </AccordionSummary>
      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAcordion;
